import { Bunker } from 'src/types';
import { bunkerTypes } from 'src/directories';
import { toFiniteDecimal } from './number.utils';

const BDN_EXEMPT_BUNKER_GRADES = new Set(['butane']);

export const getEmptyBunkerMessage = (
  bunker: Pick<Bunker, 'grade' | 'remainingOnboardMt' | 'consumptionMt' | 'receivedMt'>
): string | null => {
  if (!bunker.grade || bunker.grade.toLowerCase() === 'lng') {
    return null;
  }

  const quantities = [bunker.remainingOnboardMt, bunker.consumptionMt, bunker.receivedMt];
  if (!quantities.every((quantity) => toFiniteDecimal(quantity)?.isZero())) {
    return null;
  }

  const grade = bunker.grade.toUpperCase();
  const receivedFieldLabel = bunkerTypes.some(({ value }) => value === bunker.grade.toLowerCase())
    ? 'Received bunker'
    : 'Bunker correction';
  return `Remaining onboard, Consumption and ${receivedFieldLabel} are all 0. Check the values or remove ${grade} from this report.`;
};

export const requiresBunkerDeliveryNote = (
  grade: string | null | undefined,
  receivedMt: string | number | null | undefined,
  bdnEnabled: boolean
): boolean =>
  bdnEnabled && Number(receivedMt || 0) > 0 && !BDN_EXEMPT_BUNKER_GRADES.has(grade?.toLowerCase() ?? '');
